const button = {
    cancel: 'Cancel',
    ok: 'OK',

    no: 'No',
    yes: 'Yes',
    library: 'Library',
    save: 'Save',
};

export default button;
